export class CSVUtils {
    static escapeCsvItem(value?: string): string {
        if ('undefined' === value) {
            return '';
        }
        if (value.includes(',')) {
            value = value.replace('"', '""');
            return `"${value}"`;
        }
        return value;
    }
}
